var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { Component, Prop, Mixins } from 'vue-property-decorator';
import { Validatable } from '@/common/mixins/Validatable';
import { Savable } from '@/common/mixins/Savable';
import { InvestmentBudgetaryEstimate } from '@/common/types/InvestmentBudgetaryEstimate';
import { EstimateType } from '@/common/types/EstimateType';
import { BAidType } from '@/common/types/BAidType';
import { Guid } from "guid-typescript";
import { LineItem } from '@/common/types/LineItem';
import EstimateItemWrapper from '@/common/types/EstimateItemWrapper';
import { AmountItemType } from '@/common/types/AmountItemType';
var InvestmentBudgetaryEstimateBase = /** @class */ (function (_super) {
    __extends(InvestmentBudgetaryEstimateBase, _super);
    function InvestmentBudgetaryEstimateBase() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(InvestmentBudgetaryEstimateBase.prototype, "fundingWrappers", {
        get: function () {
            switch (this.type) {
                case BAidType.ICTAndFixedAssets:
                    return this.buildWrappersFunding(this.item.ict.funding);
                case BAidType.PremisesRenovationOrImprovement:
                    return this.buildWrappersFunding(this.item.premises.funding);
                case BAidType.SupportApartments:
                    return this.buildWrappersFunding(this.item.supportApartments.funding);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InvestmentBudgetaryEstimateBase.prototype, "features", {
        get: function () {
            var config = this.$store.state.vuexPageModule.configuration;
            return config.featureConfiguration;
        },
        enumerable: false,
        configurable: true
    });
    InvestmentBudgetaryEstimateBase.prototype.buildWrappersFunding = function (item) {
        var e_1, _a;
        var _this = this;
        var wrappers = [];
        var _loop_1 = function (funding) {
            switch (funding.type) {
                case EstimateType.Profits_SelfCoveredFunding:
                    wrappers.push(new EstimateItemWrapper(funding, function () { return _this.type == BAidType.PremisesRenovationOrImprovement || _this.type == BAidType.SupportApartments || (_this.type == BAidType.ICTAndFixedAssets && funding.yearlyItems[0].value > 0); }));
                    break;
                case EstimateType.Profits_OtherGovernmentAid:
                    wrappers.push(new EstimateItemWrapper(funding, function () { return funding.yearlyItems.find(function (x) { return x.value > 0; }) != undefined; }));
                    break;
                default:
                    wrappers.push(new EstimateItemWrapper(funding));
            }
        };
        try {
            for (var _b = __values(item.breakdown), _c = _b.next(); !_c.done; _c = _b.next()) {
                var funding = _c.value;
                _loop_1(funding);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return wrappers;
    };
    /**
     * Create new line item.
     * @param columns columns
     */
    InvestmentBudgetaryEstimateBase.prototype.createNewLineItem = function (columns) {
        var lineItem = new LineItem();
        lineItem.name = null;
        lineItem.isReadOnly = false;
        lineItem.isLocalized = false;
        lineItem.canDelete = true;
        lineItem.key = "UserAdded." + Guid.create().toString();
        lineItem.type = null;
        var amountItems = [];
        for (var i = 0; i < columns.length; i++) {
            amountItems.push({
                amount: null,
                isComputed: false,
                isReadOnly: false,
                isRequired: i == 0,
                columnKey: columns[i].value,
                lineItemKey: lineItem.key,
                type: AmountItemType.Undefined
            });
        }
        lineItem.amountItems = amountItems;
        return lineItem;
    };
    var _a, _b;
    __decorate([
        Prop(Object),
        __metadata("design:type", typeof (_a = typeof InvestmentBudgetaryEstimate !== "undefined" && InvestmentBudgetaryEstimate) === "function" ? _a : Object)
    ], InvestmentBudgetaryEstimateBase.prototype, "item", void 0);
    __decorate([
        Prop(Number),
        __metadata("design:type", typeof (_b = typeof BAidType !== "undefined" && BAidType) === "function" ? _b : Object)
    ], InvestmentBudgetaryEstimateBase.prototype, "type", void 0);
    __decorate([
        Prop({ type: Function }),
        __metadata("design:type", Function)
    ], InvestmentBudgetaryEstimateBase.prototype, "profitsNumericInputRules", void 0);
    InvestmentBudgetaryEstimateBase = __decorate([
        Component({
            name: 'InvestmentBudgetaryEstimateBase'
        })
    ], InvestmentBudgetaryEstimateBase);
    return InvestmentBudgetaryEstimateBase;
}(Mixins(Validatable, Savable)));
export default InvestmentBudgetaryEstimateBase;
